export default {
  SET_CURRENT_TAB: 'SET_CURRENT_TAB',
};
